import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import PageHero from '@/components/feature/PageHero';
import CtaSection from '@/components/feature/CtaSection';
import { services } from '@/mocks/services';

const heroImg = '/assets/klob-hero-services.jpg';

export default function Leistungen() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-50 font-sans">
      <Header />
      <main>
        <PageHero
          eyebrow="Unsere Leistungen"
          title={<>Handwerk aus <span className="text-primary-500">einer Hand</span></>}
          subtitle="Vom ersten Anstrich bis zum kompletten Innenausbau — wir übernehmen Putz-, Maler-, Estrich- und Fliesenarbeiten fachgerecht und sauber."
          image={heroImg}
        />

        <section className="bg-background-50 py-16 lg:py-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex flex-wrap gap-3">
              {services.map((s) => (
                <a
                  key={s.slug}
                  href={`#${s.slug}`}
                  className="inline-flex items-center gap-2 rounded-full border border-background-300/60 bg-background-100 px-4 py-2 text-sm text-foreground-100 cursor-pointer transition-colors hover:border-primary-500/60 hover:text-primary-400 whitespace-nowrap"
                >
                  <span className="font-mono text-xs text-primary-400">{s.num}</span>
                  {s.title}
                </a>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-50 pb-24 lg:pb-32">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col gap-20 lg:gap-28">
            {services.map((s, idx) => (
              <article
                key={s.slug}
                id={s.slug}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center scroll-mt-28 ${
                  idx % 2 === 1 ? 'lg:[&>div:first-child]:order-2' : ''
                }`}
              >
                <div className="relative">
                  <div className="relative aspect-[4/3] overflow-hidden rounded-sm border border-background-300/60">
                    <img src={s.img} alt={s.title} className="w-full h-full object-cover object-top" />
                    <span className="absolute left-4 top-4 rounded bg-background-50/60 px-3 py-1 font-mono text-sm text-primary-300 backdrop-blur">
                      {s.num}
                    </span>
                  </div>
                </div>
                <div>
                  <h2 className="font-display text-3xl sm:text-4xl font-bold uppercase tracking-tight text-foreground-50">
                    {s.title}
                  </h2>
                  <p className="mt-4 text-lg leading-relaxed text-foreground-100/80">{s.desc}</p>
                  <p className="mt-4 leading-relaxed text-foreground-400">{s.longText}</p>
                  <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-start gap-2 text-sm text-foreground-100/85">
                        <i className="ri-checkbox-circle-line text-primary-400 mt-0.5"></i>
                        {f}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </section>

        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}